<template>
    <div v-if="!hasAcceptedCookie" class="cookie-accept">
        <div class="title">Этот веб-сайт использует файлы cookie</div>
        <div class="text">
            ПАО «Ростелеком» обрабатывает
            <button class="primary no-border" @click="openCookie">Cookies</button>
            для корректной работы сайта и персонализации сервисов, в т.ч.
            с использованием метрических программ и систем аналитики. Вы можете запретить обработку
            <button class="primary no-border" @click="openCookie">Cookies</button>
            в настройках браузера.
        </div>
        <button class="accept primary" @click="acceptCookies">Принять</button>
        <Cookies ref="cookie" />
    </div>
</template>

<script>
import Local from '@/common/util/local.js';
import Cookies from '@/common/page_comp/PrivacyPolice/Cookie.vue';

const COOKIE_ACCEPT_KEY = 'COOKIE_ACCEPT';

export default {
    name: 'CookieAccept',
    components: { Cookies },
    data() {
        return {
            hasAcceptedCookie: false,
        };
    },
    created() {
        this.checkAcceptCookie();
    },
    methods: {
        openCookie() {
            this.$refs.cookie.open();
        },
        acceptCookies() {
            Local.put(COOKIE_ACCEPT_KEY, true);
            this.hasAcceptedCookie = true;
        },
        checkAcceptCookie() {
            this.hasAcceptedCookie = Local.get(COOKIE_ACCEPT_KEY, false);
        },
    },
};
</script>


<style lang="scss" scoped>
.cookie-accept {
    position: fixed;
    right: 10px;
    bottom: 60px;
    z-index: 2;
    max-width: 500px;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0px 8px 20px rgba(28, 41, 61, 0.1);
    background-color: #F9F9FB;

    .title {
        font-size: 16px;
        line-height: 22px;
        font-weight: 700;
        margin-bottom: 8px;
    }

    .text {
        margin-bottom: 20px;
    }
}
</style>
